import React from 'react';

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="site-footer">
            <div className="container">
                <p>&copy; {year} Snox. All rights reserved.</p>
                <p>
                    <a href="https://snoxpro.com/terms_and_conditions.html" className="mx-2">Terms of Service</a> |
                    <a href="https://snoxpro.com/privacy_policy.html" className="mx-2">Privacy Policy</a>
                </p>
            </div>
        </footer>
    );
};

export default Footer;